import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonCellRunResultModel extends ModeModelBase {
  override _name = 'pythonCellRunResult';

  result: () => any;
  content: any;
  contentPromise: any;
  result_type: string;

  override belongsTo = 'pythonCellRun';
  override parentIdAttribute = 'token';
  override idAttribute = 'token';
  override attributes = [
    { name: 'result_type', default: '' },
    { name: 'content_type', default: '' },
  ];
  override initialize(resource) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.result = () => {
      if (self.content) {
        delete self.contentPromise;
        const deferred = this.injectables.$q.defer();
        deferred.resolve(self);
        return deferred.promise;
      } else if (self.contentPromise) {
        return self.contentPromise;
      } else {
        const deferred = this.injectables.$q.defer();
        if (self.result_type === 'image' || self.result_type === 'csv') {
          // no need to download image or csv data just save link
          self.content = self._resource.links('web_result').href;
          deferred.resolve(self);
          return deferred.promise;
        }
        // this is raw data so pass an empty transformResponse to avoid JSON parsing
        self._resource
          .links('result')
          .$get({}, null, { responseType: 'text' })
          .then((response) => {
            self.content = response.data;
            deferred.resolve(self);
            delete self.contentPromise;
          })
          .catch((e) => {
            delete self.contentPromise;
            deferred.reject(e);
          });

        self.contentPromise = deferred.promise;
        return self.contentPromise;
      }
    };
  }
}

@Injectable({ providedIn: 'root' })
export class PythonCellRunResultModelAccessor extends ModelAccessorBase<PythonCellRunResultModel> {
  override name = 'pythonCellRunResult';
  override idAttribute = 'token';
  override parentModel = 'pythonCellRun';
  override parentIdAttribute = 'token';
  override getIdFromLink = (link) => {
    return link.split('?')[0];
  };

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonCellRunResult');
  }

  createModel(resource, opts?) {
    const model = new PythonCellRunResultModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
